import type {
  CustomPost,
  Post,
} from '@/types/schema/directory/collaboration-record'

const isCustomPost = (post: Post | CustomPost): post is CustomPost => {
  return 'is_custom_post_type' in post && 'is_custom_platform' in post
}

export default isCustomPost
